import { useMemo } from 'react';
import { GroupByMode, TaskGroupBy } from 'shared/types/sorting-mode';
import { Tag } from 'shared/types/tag';
import { noGroupingId } from 'shared/views/task-filter-list';

export const useTagCustomOrderByGrouping = (
  groupBy: TaskGroupBy | undefined | null,
  tag?: Tag,
) =>
  useMemo(() => {
    if (!tag?.id) {
      return {};
    }
    const _groupBy = (
      [GroupByMode.None, GroupByMode.LifeArea].includes(groupBy!)
        ? GroupByMode.Priority // Default to Priority if no grouping or Tag grouping (avoid recursion/nonsense)
        : groupBy ?? GroupByMode.Priority
    ) as Exclude<GroupByMode, GroupByMode.None | GroupByMode.LifeArea>;

    if (groupBy === GroupByMode.None) {
      return {
        [noGroupingId]: tag.taskSorting ?? [],
      };
    }

    return tag.customTaskOrder?.[_groupBy] ?? {};
  }, [tag?.customTaskOrder, tag?.id, tag?.taskSorting, groupBy]);
